<template>
  <section class="container-fluid">
    <CRow class="justify-content-center">
      <CCol sm="8">
        <CCard>
          <CCardHeader>
            <strong>Editar estudiante</strong>
          </CCardHeader>
          <CCardBody>
            <ValidationObserver ref="form" v-slot="{ invalid }">
              <form @submit.prevent="edit" v-if="student.id !== null">
                <section class="row">
                  <!-- Apellidos -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-3">
                    <div class="form-group required">
                      <ValidationProvider
                        name="last_name"
                        rules="required|max:120"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="last_name"
                          >Apellidos</label
                        >
                        <input
                          type="text"
                          v-model="student.person.last_name"
                          class="form-control form-control-sm"
                          id="last_name"
                          maxlength="120"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Nombres -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-3">
                    <div class="form-group required">
                      <ValidationProvider
                        name="first_name"
                        rules="required|max:120"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="first_name"
                          >Nombres</label
                        >
                        <input
                          type="text"
                          v-model="student.person.first_name"
                          class="form-control form-control-sm"
                          id="first_name"
                          maxlength="120"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Documento -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-2">
                    <div class="form-group required">
                      <ValidationProvider
                        name="document_number"
                        rules="uniqueDocumentNumber|required|max:30"
                        :debounce="500"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="document_number"
                          >Documento</label
                        >
                        <input
                          type="text"
                          v-model="student.person.document_number"
                          class="form-control form-control-sm"
                          id="document_number"
                          maxlength="30"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Emitido en: -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-2">
                    <div class="form-group required">
                      <ValidationProvider
                        name="document_issued"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="document_issued"
                          >Emitido en:
                        </label>
                        <b-form-select
                          v-model="student.person.document_issued"
                          :options="documentIssuedOptions"
                          id="document_issued"
                          size="sm"
                        >
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Género: -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-2">
                    <div class="form-group required">
                      <ValidationProvider
                        name="gender"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="gender"
                          >Género:
                        </label>
                        <b-form-select
                          v-model="student.person.gender"
                          :options="genderOptions"
                          value-field="value"
                          text-field="name"
                          id="gender"
                          size="sm"
                        >
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Dirección -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-3">
                    <div class="form-group required">
                      <ValidationProvider
                        name="address"
                        rules="required|max:150"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="address"
                          >Dirección</label
                        >
                        <input
                          type="address"
                          v-model="student.person.address"
                          class="form-control form-control-sm"
                          id="address"
                          maxlength="150"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Email -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-3">
                    <div class="form-group">
                      <ValidationProvider
                        name="email"
                        rules="uniqueEmail|email|max:150"
                        :debounce="500"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="email">Email</label>
                        <input
                          type="email"
                          v-model="student.person.email"
                          class="form-control form-control-sm"
                          id="email"
                          maxlength="150"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Celular 1 -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-2">
                    <div class="form-group required">
                      <ValidationProvider
                        name="mobile"
                        rules="required|max:15|regex:^[0-9-()+ ]*$"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="mobile"
                          >Celular (1)</label
                        >
                        <input
                          type="text"
                          v-model="student.person.mobile"
                          class="form-control form-control-sm"
                          id="mobile"
                          maxlength="15"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Celular 2 -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-2">
                    <div class="form-group">
                      <ValidationProvider
                        name="mobile_alternative"
                        rules="max:15|regex:^[0-9-()+ ]*$"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="mobile_alternative"
                          >Celular (2)
                        </label>
                        <input
                          type="text"
                          v-model="student.person.mobile_alternative"
                          class="form-control form-control-sm"
                          id="mobile_alternative"
                          maxlength="15"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Teléfono -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-2">
                    <div class="form-group">
                      <ValidationProvider
                        name="phone"
                        rules="max:15"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="phone"
                          >Teléfono</label
                        >
                        <input
                          type="text"
                          v-model="student.person.phone"
                          class="form-control form-control-sm"
                          id="phone"
                          maxlength="15"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Fecha de nacimiento -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-4">
                    <div class="form-group">
                      <ValidationProvider
                        name="birth_date"
                        rules="max:15|regex:^[0-9-()+ ]*$"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="birth_date"
                          >Fecha de nacimiento
                        </label>
                        <flat-pickr
                          v-model="student.person.birth_date"
                          :config="configDate"
                          class="form-control form-control-sm"
                        ></flat-pickr>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Lugar de origen -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-4">
                    <div class="form-group required">
                      <ValidationProvider
                        name="origin_place_id"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="origin_place_id"
                          >Lugar de origen
                        </label>
                        <b-form-select
                          v-model="student.person.origin_place_id"
                          :options="originPlacesOptions"
                          value-field="id"
                          text-field="name"
                          id="origin_place_id"
                          size="sm"
                        >
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Lengua nativa -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-4">
                    <div class="form-group required">
                      <ValidationProvider
                        name="native_language_id"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="native_language_id"
                          >Lengua nativa
                        </label>
                        <b-form-select
                          v-model="student.person.native_language_id"
                          :options="nativeLanguagesOptions"
                          value-field="id"
                          text-field="name"
                          id="native_language_id"
                          size="sm"
                        >
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Nivel de idioma inicial -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-4">
                    <div class="form-group required">
                      <ValidationProvider
                        name="initial_language_level"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label
                          class="control-label"
                          for="initial_language_level"
                          >Nivel de idioma inicial
                        </label>
                        <b-form-select
                          v-model="student.initial_language_level"
                          :options="initialLanguageLevelOptions"
                          value-field="value"
                          text-field="name"
                          id="initial_language_level"
                          size="sm"
                        >
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Grado académico: -->
                  <div class="col-6 col-sm-6 col-md-4 col-xl-4">
                    <div class="form-group required">
                      <ValidationProvider
                        name="academic_degree"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="academic_degree"
                          >Grado académico:
                        </label>
                        <b-form-select
                          v-model="student.person.academic_degree"
                          :options="academicDegreeOptions"
                          value-field="value"
                          text-field="name"
                          id="academic_degree"
                          size="sm"
                        >
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Ocupación -->
                  <div class="col-12 col-sm-6 col-md-4 col-xl-4">
                    <div class="form-group">
                      <ValidationProvider
                        name="occupation"
                        rules="max:150"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="occupation"
                          >Ocupación</label
                        >
                        <input
                          type="occupation"
                          v-model="student.person.occupation"
                          class="form-control form-control-sm"
                          id="occupation"
                          maxlength="150"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Pénsum -->
                  <div class="col-12 col-sm-6 col-md-4 col-xl-6">
                    <div class="form-group required">
                      <ValidationProvider
                        name="syllabus_id"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="syllabus_id"
                          >Pénsum</label
                        >
                        <b-form-select
                          v-model="student.syllabus_id"
                          :options="syllabusOptions"
                          value-field="id"
                          text-field="description"
                          id="syllabus_id"
                          size="sm"
                        >
                          <b-form-select-option :value="null"
                            >--Seleccione un pénsum--</b-form-select-option
                          >
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Tipo de pensíon -->
                  <StudentSyllabusTuition
                    :syllabus_id="student.syllabus_id"
                    v-model="student.syllabus_tuition_id"
                    @syllabus_tuition="setSyllabusTuition"
                  ></StudentSyllabusTuition>
                  <!-- Detalle -->
                  <div class="col-12 col-sm-6 col-md-4 col-xl-12">
                    <div class="form-group">
                      <label class="control-label" for="detail">Detalle</label>
                      <textarea
                        v-model="student.person.detail"
                        class="form-control"
                        id="detail"
                        rows="3"
                      ></textarea>
                    </div>
                  </div>
                  <!-- Usuario -->
                  <div class="col-12 col-sm-6 col-md-4 col-xl-6">
                    <div class="form-group">
                      <label class="control-label" for="username"
                        >Usuario</label
                      >
                      <input
                        type="username"
                        v-model="student.person.user.username"
                        class="form-control form-control-sm"
                        id="username"
                        readonly
                      />
                    </div>
                  </div>
                </section>
                <router-link
                  to="/estudiantes"
                  class="card-header-action btn btn-sm btn-danger"
                >
                  <CIcon size="sm" name="cil-x-circle" /> Cancelar
                </router-link>

                <button
                  type="submit"
                  class="btn btn-success btn-sm float-right"
                  variant="success"
                  :disabled="invalid || editLoader"
                >
                  <span v-if="!editLoader">
                    <CIcon size="sm" name="cil-save" /> Guardar
                  </span>
                  <span v-if="editLoader">
                    Cargando
                    <CSpinner color="success" size="sm" />
                  </span>
                </button>
              </form>
            </ValidationObserver>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import {
  BFormInvalidFeedback,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import Constants from "@/plugins/constants";
import { required, email, max, min, regex } from "vee-validate/dist/rules";
//services
import People from "@/plugins/services/people";
import Students from "@/plugins/services/students";
import OriginPlaces from "@/plugins/services/origin-places";
import NativeLanguages from "@/plugins/services/native-languages";
import Syllabus from "@/plugins/services/syllabus";
// componentes
import StudentSyllabusTuition from "@/entities/students/student-syllabus-tuition/student-syllabus-tuition";

export default {
  name: "StudentsEdit",
  components: {
    BFormInvalidFeedback,
    BFormSelect,
    BFormSelectOption,
    StudentSyllabusTuition,
  },
  data() {
    return {
      student: {
        id: null,
      },
      current_email: "",
      editLoader: false,
      configDate: {
        dateFormat: "d-m-Y",
        showMonths: 1,
        allowInput: true,
      },
      initialLanguageLevelOptions: Constants.initialLanguageLevelOptions,
      documentIssuedOptions: Constants.documentIssuedOptions,
      genderOptions: Constants.genderOptions,
      academicDegreeOptions: Constants.academicDegreeOptions,
      originPlacesOptions: [],
      nativeLanguagesOptions: [],
      syllabusOptions: [],
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  mounted() {
    const { id } = this.$route.params;
    this.getData(id);
    this.getOriginPlaces();
    this.getNativeLanguages();
    this.getSyllabus();
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido.",
    });

    extend("email", {
      ...email,
      message: "El email tiene un formato incorrecto.",
    });

    extend("uniqueEmail", {
      validate: this.isEmailUnique,
      message: "El email ya existe.",
    });

    extend("uniqueDocumentNumber", {
      validate: this.isDocumentNumberUnique,
      message: "El documento ya existe.",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });

    extend("min", {
      ...min,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como mínimo.",
    });

    extend("regex", {
      ...regex,
      message: "Datos no válidos.",
    });
  },
  methods: {
    getData(id) {
      this.dataLoader = true;
      Students.getOne(id)
        .then((res) => {
          this.student = res.data;
          this.current_email = this.student.person.email;
          this.username_current = this.student.person.username;
          this.current_document_number = this.student.person.document_number;
          this.dataLoader = true;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Usuario no encontrado.");
            this.$router.push("/estudiantes");
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.$router.push("/estudiantes");
          }
          this.dataLoader = false;
        });
    },
    edit() {
      const { id } = this.$route.params;
      this.editLoader = true;
      this.student.modified_by = this.userAuth.username;
      Students.edit(id, this.student)
        .then((res) => {
          this.editLoader = false;
          if (res.data.success) {
            Utils.setFlash("success", res.data.message);
            this.$router.push("/estudiantes");
          } else {
            Utils.setFlash("danger", res.data.message);
            this.$router.push("/estudiantes");
          }
        })
        .catch((err) => {
          this.editLoader = false;
          if (err.response && err.response.status == 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Estudiante no encontrado.");
            this.$router.push("/estudiantes");
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error al guardar(500).");
            this.$router.push("/estudiantes");
          }
        });
    },
    async isEmailUnique() {
      return People.existEmail(this.student.person.email, this.current_email)
        .then((res) => {
          if (res.data.data) {
            return false;
          } else {
            return true;
          }
        })
        .catch((err) => {
          return true;
        });
    },
    async isDocumentNumberUnique() {
      return People.existDocumentNumber(
        this.student.person.document_number,
        this.current_document_number
      )
        .then((res) => {
          if (res.data.data) {
            return false;
          } else {
            return true;
          }
        })
        .catch((err) => {
          return true;
        });
    },
    getOriginPlaces() {
      OriginPlaces.selectAll(null)
        .then((res) => {
          this.originPlacesOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getNativeLanguages() {
      NativeLanguages.selectAll(null)
        .then((res) => {
          this.nativeLanguagesOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSyllabus() {
      Syllabus.selectAll({ enabled: true })
        .then((res) => {
          this.syllabusOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setSyllabusTuition(response) {
      if (response.data !== null) {
        this.student.syllabus_tuition_id = response.data.id;
      } else {
        this.student.syllabus_tuition_id = null;
      }
    },
  },
};
</script>
